import { createComponentPreviewMapperModel } from '@wix/editor-elements-integrations';
import {
  composeMapper,
  getDesignPanelPreviewStateMap,
} from '@wix/editor-elements-preview-utils';
import type { PreviewWrapperProps } from '@wix/editor-elements-types/thunderboltPreview';
import type { GalleryViewMode } from '../ProGallery.types';

import { props as viewerPropsMapper } from './ProGallery.mapper';

// TODO - fix types

const formatDataPreview = (
  designPanelPreviewStateMap: Record<string, string> | undefined,
): string | undefined => {
  // the gallery inner elements are not written in EE so we accessed them globally through the gallery root
  const { selectedPartId, selectedStateId, hoveredStateId } =
    designPanelPreviewStateMap || {};
  return (
    selectedPartId &&
    (selectedStateId || hoveredStateId) &&
    `${selectedPartId}-${hoveredStateId || selectedStateId}`
  );
};
const props = composeMapper<PreviewWrapperProps<any>, any, any>()(
  viewerPropsMapper,
  { add: ['componentViewMode', 'compPreviewState'] },
  (resolver, dependencies, carmiData) => {
    const viewerProps = resolver(dependencies, carmiData);

    const { componentViewMode, compPreviewState } = dependencies;

    const viewMode: GalleryViewMode =
      componentViewMode === 'editor' ? 'EDIT' : 'PREVIEW';

    const designPanelPreviewStateMap =
      getDesignPanelPreviewStateMap(compPreviewState);

    const allowFullscreen = componentViewMode === 'editor';

    return {
      ...viewerProps,
      viewMode,
      allowFullscreen,
      partToPreview: formatDataPreview(designPanelPreviewStateMap),
    };
  },
);

export default createComponentPreviewMapperModel({
  props,
});
